/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_Store_DescriptionInputs */



/**
* | output |
* | --- |
* | "Install ready-made personas for your organization. Once installed, everyone in your organization can use them." |
*
* @param {Personas_Store_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_store_description = /** @type {((inputs?: Personas_Store_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Store_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Installieren Sie vorgefertigte Personas für Ihre Organisation. Nach der Installation können alle in Ihrer Organisation sie verwenden.")
	return /** @type {LocalizedString} */ ("Install ready-made personas for your organization. Once installed, everyone in your organization can use them.")
});